var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbarPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_6_1",
    "data-name": "Component 6 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.021,
    height: 18.682,
    viewBox: "0 0 26.021 18.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 16.158, 6.176)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.105,
    cy: 5.105,
    rx: 5.105,
    ry: 5.105,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.105,
    cy: 5.105,
    rx: 4.605,
    ry: 4.605,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "matrix(-0.469, 0.883, -0.883, -0.469, 15.901, 6.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M4.605,0,9.21,8.439H0Z",
    transform: "translate(0 0)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 5.814,
    height: 4.272,
    transform: "translate(6.756 7.298) rotate(90)",
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarPoint);
export default __webpack_public_path__ + "static/media/toolbar-point.5ecc38ab7c3d17cb5560c718a914cc5e.svg";
export { ForwardRef as ReactComponent };